"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTicketingCreatedSubject = void 0;
/**
 * Mirrors packages/server/src/i18n/{locale}/notification.json's "ticketingCreated.subject" key.
 * The server computes this subject ONCE, before branching on form category or auction
 * (ticketing-notification.service.ts) — so it's the real subject line for BOTH
 * organization/ticketing-created.hbs and organization/auction-created.hbs, not just the former.
 * Both mock-data builders share it here rather than each hardcoding an English-only,
 * non-interpolated default that drifts from what's actually sent.
 */
const locales_1 = require("../../internationalization/enums/locales");
const locales_2 = require("../../internationalization/features/locales");
const TICKETING_CREATED_SUBJECT_BY_LOCALE = (0, locales_2.buildLocaleRecord)({
    [locales_1.Locales.EN]: "{formTitle} is ready!",
    [locales_1.Locales.FR]: "{formTitle} est prêt !",
    [locales_1.Locales.ES]: "¡{formTitle} ya está listo!",
    [locales_1.Locales.DE]: "{formTitle} ist bereit!",
});
const buildTicketingCreatedSubject = (locale, formTitle) => {
    const template = TICKETING_CREATED_SUBJECT_BY_LOCALE[locale.toUpperCase()] ?? TICKETING_CREATED_SUBJECT_BY_LOCALE.EN;
    return template.replace("{formTitle}", formTitle);
};
exports.buildTicketingCreatedSubject = buildTicketingCreatedSubject;
